import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=5eec216a"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports